
import { controls } from '~/mixins/carousel'
export default {
  mixins: [controls],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
}
